import * as React from 'react';

import Grid from '@mui/material/Grid';

import { AtomButton } from '@app/common/atoms';
import { ILocationProps } from '@app/common/interfaces';
import androidLogo from '@app/imageAssets/androidLogo.png';
import cordovaLogo from '@app/imageAssets/cordovaLogo.png';
import iosLogo from '@app/imageAssets/iosLogo.png';
import unityLogo from '@app/imageAssets/unityLogo.png';
import { SignUp } from '@app/modules/SignUpFlow/modules/SignUp';

import { RenderArgs, Typewriting } from './TypeWriting';

class HomePageIntroduction extends React.PureComponent<ILocationProps> {
  public redirectToSignUp = (): void => {
    window.location.href = '/users/sign_up';
  };

  public render(): JSX.Element {
    return (
      <Grid
        item={true}
        container={true}
        className="home-page__introduction-container"
        spacing={3}
        justifyContent={'center'}
      >
        <Grid item={true} xs={10} md={5} lg={4}>
          <div className="home-page__introduction-description">
            <h1 data-qa="home-page__main-title">
              Unlock the power <br />
              <span className="home-page__introduction-mobile-gaming-of">of&nbsp;</span>
              <span className="home-page__introduction-mobile-gaming-underline">
                <Typewriting
                  strings={['competition', 'real prizes', 'esports', 'mobile games']}
                  waitBeforeDeleteMs={1750}
                  writeSpeedMs={200}
                  deleteSpeedMs={150}
                >
                  {({ currentText, fullCurrentText }: RenderArgs): JSX.Element => (
                    <h1 aria-label={fullCurrentText}>{currentText}</h1>
                  )}
                </Typewriting>
              </span>
              <span className="blink">|</span>
            </h1>
            <p>
              Skillz is the next evolution of mobile gaming. Our multiplayer competition platform
              brings tournaments and real prizes to your players - boosting your game’s success.
              <br />
              <br />
              Always free. Get started today.
            </p>
          </div>
        </Grid>
        <Grid item={true} xs={10} md={5} lg={4}>
          <div className="home-page__introduction-signup-form-container">
            <SignUp />
          </div>

          <div className="home-page__introduction-signup-button-container">
            <AtomButton
              id="home-page__introduction-sign-up-button"
              buttonContent="SIGN UP"
              buttonType="primary"
              onClick={this.redirectToSignUp}
            />
          </div>
        </Grid>
        <Grid item={true} xs={10} className="home-page__introduction-platform-logos">
          <img src={iosLogo} width="21px" height="25px" />
          <img src={androidLogo} width="25px" height="25px" />
          <img src={unityLogo} width="25px" height="25px" />
          <img src={cordovaLogo} width="25px" height="25px" />
        </Grid>
      </Grid>
    );
  }
}

export { HomePageIntroduction };
